module.exports = __webpack_public_path__ + "images/9d82b87b7507abf3abdc8ca0e26cf211.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/icons/mail.svg
// module id = 835
// module chunks = 0